// extracted by mini-css-extract-plugin
module.exports = {"productList":"ProductList-module--productList--2wsic","listHeading":"ProductList-module--listHeading--nrmZ-","title":"ProductList-module--title--2jA-w"};